// Central registry of Datadog (OpenFeature) driven flags used for AB testing.
// Add new experiments here instead of hardcoding flag keys in components.
export const OneMedicalMonthlyYearlyDeductibleFlag = {
  key: 'one-medical-monthly-yearly-deductible',
} as const;
